/**
 * Small pill rendered next to a draft cart line / fired order line — shows
 * the participant who added it. Used by CartScreen + DineInOrderScreen.
 */
import type { GroupCartParticipant } from "@/api/group-cart";
import { colorFor } from "@/lib/participant-colors";
import { initialFor } from "./Avatar";

export interface AttributionChipProps {
  participant: GroupCartParticipant;
  /** Hard truncate the displayed name (default 10). */
  truncate?: number;
}

export function AttributionChip({
  participant,
  truncate = 10,
}: AttributionChipProps) {
  const color = colorFor(participant.colorIndex);
  const name =
    participant.displayName.length > truncate
      ? `${participant.displayName.slice(0, truncate)}…`
      : participant.displayName;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: "2px 8px 2px 4px",
        borderRadius: 999,
        background: color.soft,
        color: color.fg,
        fontSize: 11,
        fontWeight: 700,
        lineHeight: 1.2,
        letterSpacing: 0.1,
      }}
      title={participant.displayName}
    >
      <span
        aria-hidden
        style={{
          width: 16,
          height: 16,
          borderRadius: 999,
          background: color.strong,
          color: "#fff",
          display: "grid",
          placeItems: "center",
          fontSize: 9,
          fontWeight: 800,
        }}
      >
        {initialFor(participant)}
      </span>
      {name}
    </span>
  );
}
